import { MolhamLanguagesObject } from "apiTypes";
import MolhamInput from "components/ReuseableCompos/MolhamInput";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { memo } from "react";
import { useFormContext } from "react-hook-form";
type Props = {
  data: {
    id: number;
    name: MolhamLanguagesObject;
  }[];
};
const Step1 = ({ data }: Props) => {
  const {
    register,
    watch,
    formState: { errors },

    control,
  } = useFormContext();
  const { t } = useTranslation("common");
  const { locale } = useRouter();

  return (
    <div>
      <MolhamInput
        control={control}
        name="title"
        watch={watch}
        labelSize="lg"
        label={t(`event_title`)}
        placeholder={t(`event_title`)}
      />
      <div className={`${errors.title?.message ? "" : "mb-3"}`}>
        <label className="form-label fs-lg" htmlFor="category">
          {t(`event_category`)}
        </label>
        <select
          key={data[0]?.id + ""}
          className="form-select"
          id="category_id"
          {...register("category_id")}
        >
          {data?.map((item) => {
            return (
              <option key={item.id + ""} value={item.id + ""}>
                {item.name?.[locale]}
              </option>
            );
          })}
        </select>
        <div className="invalid-feedback">
          {t(errors.category_id?.message as string)}
        </div>
      </div>
    </div>
  );
};

export default memo(Step1);
